import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [51.509748, -0.074924, 18.6],
  [51.509721, -0.075216, 18.6],
  [51.509641, -0.075486, 18.2],
  [51.509566, -0.075754, 18],
  [51.509453, -0.076339, 18],
  [51.50941, -0.076639, 18.2],
];

export default stream;
